import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import actions from '../actions';
import canEditBoardContent from '../utils/can-edit-board-content';
import List from '../components/List';

const hasEmployeeLevelsReadyForClose = (employeeLevels) => {
  if (!Array.isArray(employeeLevels) || employeeLevels.length === 0) {
    return true;
  }

  return employeeLevels.every((entry) => {
    if (entry.workedDays === null || entry.workedDays === undefined || entry.workedDays === '') {
      return false;
    }

    const workedDays = Number(entry.workedDays);
    return Number.isFinite(workedDays) && workedDays >= 0;
  });
};

const makeMapStateToProps = () => {
  const selectListById = selectors.makeSelectListById();
  const selectCardIdsByListId = selectors.makeSelectCardIdsByListId();
  const selectListReportDataByListId = selectors.makeSelectListReportDataByListId();
  const selectListPointsSum = selectors.makeSelectListPointsSum();
  const selectListClosedPointsSumExcludingOtherMonth = selectors.makeSelectListClosedPointsSumExcludingOtherMonth();
  const selectShouldAutoCloseMonth = selectors.makeSelectShouldAutoCloseMonth();
  return (state, { id, index }) => {
    const { name, isPersisted, boardId } = selectListById(state, id);
    const { projectId } = selectors.selectPath(state);
    const cardIds = selectCardIdsByListId(state, id);
    const allProjectsToLists = selectors.selectProjectsToListsForCurrentUser(state);
    const currentUserMembership = selectors.selectCurrentUserMembershipForCurrentBoard(state);
    const currentUser = selectors.selectCurrentUser(state);
    const config = selectors.selectConfig(state);
    const superuserIds = Array.isArray(config?.superuserIds) ? config.superuserIds : [];
    const isSuperuser = currentUser?.id && superuserIds.map(String).includes(String(currentUser.id));

    const pointSystem = selectors.selectPointSystemForCurrentBoard(state);
    const isPointSystemEnabled = pointSystem?.isEnabled === true;
    const pointSystemId = pointSystem?.id;
    
    // Проверяем условия для отчета за месяц - доступно для всех пользователей
    const isMonthlyReportAvailable = isPointSystemEnabled;

    const listReportData = selectListReportDataByListId(state, id, pointSystemId);
    const isMonthClosed = listReportData?.closed === true;
    const hasMonthSet = !!(listReportData?.year && listReportData?.month);
    const reportYear = listReportData?.year || null;
    const reportMonth = listReportData?.month || null;
    
    console.log('[ListContainer] listReportData:', {
      listId: id,
      listReportData,
      isMonthClosed,
      hasMonthSet,
      pointSystemId,
    });

    // Проверяем условия для автоматического закрытия месяца
    const shouldAutoCloseMonth = pointSystemId && hasMonthSet && !isMonthClosed
      ? selectShouldAutoCloseMonth(state, id, pointSystemId, listReportData.year, listReportData.month) &&
        hasEmployeeLevelsReadyForClose(listReportData.employeeLevels)
      : false;

    // Если месяц уже закрыт, но в списке есть незакрытая задача или задача закрыта в другом месяце — сбрасываем закрытие
    const shouldAutoResetMonth = pointSystemId && hasMonthSet && isMonthClosed && cardIds?.length > 0
      ? !selectShouldAutoCloseMonth(state, id, pointSystemId, listReportData.year, listReportData.month)
      : false;

    console.log(`[ListContainer] listId: ${id}, shouldAutoCloseMonth:`, shouldAutoCloseMonth, {
      pointSystemId,
      hasMonthSet,
      isMonthClosed,
      year: listReportData?.year,
      month: listReportData?.month,
    });

    // Получаем сумму баллов для списка
    const pointsSum = pointSystemId ? selectListPointsSum(state, id, pointSystemId) : 0;
    
    // Получаем сумму баллов только закрытых задач (исключая закрытые в другом месяце)
    const closedPointsSumExcludingOtherMonth = pointSystemId && hasMonthSet
      ? selectListClosedPointsSumExcludingOtherMonth(state, id, pointSystemId)
      : 0;
    
    console.log(`[ListContainer] listId: ${id}, pointsSum:`, pointsSum, 'closedPointsSumExcludingOtherMonth:', closedPointsSumExcludingOtherMonth);

    return {
      id,
      index,
      name,
      isPersisted,
      cardIds,
      boardId,
      projectId,
      allProjectsToLists,
      canEdit: canEditBoardContent(currentUser, currentUserMembership),
      isSuperuser,
      isMonthlyReportAvailable,
      isMonthClosed,
      pointsSum,
      closedPointsSumExcludingOtherMonth,
      hasMonthSet,
      shouldAutoCloseMonth,
      shouldAutoResetMonth,
      reportYear,
      reportMonth,
      listReportData,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  ...bindActionCreators(
    {
      onUpdate: (data) => entryActions.updateList(id, data),
      onMove: (index) => entryActions.moveList(id, index),
      onTransfer: (boardId, addUserIds = []) =>
        entryActions.transferList(id, boardId, 0, addUserIds),
      onPrepareTransfer: (boardId) => entryActions.prepareTransferList(id, boardId),
      onClone: (boardId, navigateAfterClone = false, addUserIds = []) =>
        entryActions.cloneList(id, boardId, navigateAfterClone, addUserIds),
      onDelete: () => entryActions.deleteList(id),
      onArchive: () => entryActions.archiveList(id),
      onMonthlyReportOpen: () => entryActions.openMonthlyReportModal(id),
      onCardCreate: (data, autoOpen) => entryActions.createCard(id, data, autoOpen),
    },
    dispatch,
  ),
  onCompleteMonth: () => dispatch(entryActions.completeListReportDataByListId(id)),
  onResetMonth: (year, month) => dispatch(entryActions.upsertListReportDataByListId(id, { year, month })),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(List);
